import React from 'react';
import { Box, Typography } from '@mui/material';

const VolassisLogo = ({ size = 'medium', variant = 'default' }) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: 120, height: 60, fontSize: '1rem' };
      case 'large':
        return { width: 240, height: 120, fontSize: '2rem' };
      default:
        return { width: 180, height: 90, fontSize: '1.5rem' };
    }
  };

  const { width, height, fontSize } = getSize();
  const figureSize = height * 0.4;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: width,
        height: height,
      }}
    >
      {/* Three Human Figures */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          gap: 1,
          mb: 1,
        }}
      >
        {/* Blue Figure (Left) */}
        <Box
          sx={{
            width: figureSize * 0.6,
            height: figureSize,
            position: 'relative',
          }}
        >
          {/* Head */}
          <Box
            sx={{
              width: figureSize * 0.4,
              height: figureSize * 0.4,
              borderRadius: '50%',
              backgroundColor: '#236bbf',
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
          {/* Torso */}
          <Box
            sx={{
              width: figureSize * 0.5,
              height: figureSize * 0.6,
              backgroundColor: '#236bbf',
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: '8px 8px 0 0',
            }}
          />
        </Box>

        {/* Green Figure (Middle) */}
        <Box
          sx={{
            width: figureSize * 0.6,
            height: figureSize,
            position: 'relative',
          }}
        >
          {/* Head */}
          <Box
            sx={{
              width: figureSize * 0.4,
              height: figureSize * 0.4,
              borderRadius: '50%',
              backgroundColor: '#4caf50',
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
          {/* Torso */}
          <Box
            sx={{
              width: figureSize * 0.5,
              height: figureSize * 0.6,
              backgroundColor: '#4caf50',
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: '8px 8px 0 0',
            }}
          />
        </Box>

        {/* Purple Figure (Right) */}
        <Box
          sx={{
            width: figureSize * 0.6,
            height: figureSize,
            position: 'relative',
          }}
        >
          {/* Head */}
          <Box
            sx={{
              width: figureSize * 0.4,
              height: figureSize * 0.4,
              borderRadius: '50%',
              backgroundColor: '#9831bc',
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          />
          {/* Torso */}
          <Box
            sx={{
              width: figureSize * 0.5,
              height: figureSize * 0.6,
              backgroundColor: '#9831bc',
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: '8px 8px 0 0',
            }}
          />
        </Box>
      </Box>

      {/* Company Name */}
      <Typography
        variant={variant === 'h1' ? 'h1' : 'h2'}
        sx={{
          fontSize: fontSize,
          fontWeight: 600,
          color: '#333',
          textTransform: 'lowercase',
          letterSpacing: '0.5px',
        }}
      >
        volassis
      </Typography>
    </Box>
  );
};

export default VolassisLogo;
